import cx from "classnames";
import React, { useState } from "react";

import { BasicButton, BasicSinglelineTextInput } from "@gaming/xds-react-js";

import * as commonStyles from "../../../components/commonStyles/commonStyles.module.css";
import { StreamingEuStep, StreamingEuStepDefaultProps } from "../models";
import {
  ProviderInformationInputLabels,
  ProviderInformationParagraph1,
  ProviderInformationParagraph2Mandatory,
  ProviderInformationParagraph2Optional,
  StreamingButtonLabels,
  StreamingEuStepTitle,
} from "../streamingEuContent";
import * as styles from "../StreamingEuPage.module.css";
import { StreamingEuCloseButton } from "./StreamingEuCloseButton";

export type ProviderInformationProps = Readonly<{
  isMandatory: boolean;
}> &
  StreamingEuStepDefaultProps;

const renderInput = (
  title: string,
  value: string,
  setValue: (_value: React.SetStateAction<string>) => void,
  isRequired: boolean
) => (
  <div>
    <h2 className={styles.inputTitle}>
      {title}
      {isRequired && <span className={styles.mandatoryFieldAsterisk}>*</span>}
    </h2>
    <BasicSinglelineTextInput
      aria-required="true"
      className={commonStyles.textField}
      inputClassName={commonStyles.textFieldText}
      onChange={e => setValue(e.target.value)}
      value={value}
    />
  </div>
);

export const ProviderInformation = ({
  navigateToStep,
  isMandatory,
  storeStreamingData,
}: ProviderInformationProps) => {
  const [companyName, setCompanyName] = useState("");
  const [contactPersonLastName, setContactPersonLastName] = useState("");
  const [contactPersonFirstName, setContactPersonFirstName] = useState("");
  const [companyRole, setCompanyRole] = useState("");
  const [contactEmail, setContactEmail] = useState("");

  const isDisabled = () =>
    isMandatory &&
    (!companyName ||
      !contactPersonFirstName ||
      !contactPersonLastName ||
      !companyRole ||
      !contactEmail);

  const navigateForward = () => {
    if (isDisabled()) {
      return;
    }

    storeStreamingData({
      companyName,
      contactPersonFirstName,
      contactPersonLastName,
      companyRole,
      contactEmail,
    });
    navigateToStep(
      isMandatory ? StreamingEuStep.AccessToEntitlementData : StreamingEuStep.ThankYou
    );
  };
  return (
    <>
      <h1 className={styles.title}>
        {isMandatory
          ? StreamingEuStepTitle.ProviderInformationMandatory
          : StreamingEuStepTitle.ProviderInformationOptional}
      </h1>
      <div>
        <p>{ProviderInformationParagraph1}</p>
        <p>
          {isMandatory
            ? ProviderInformationParagraph2Mandatory
            : ProviderInformationParagraph2Optional}
        </p>
      </div>
      {renderInput(
        ProviderInformationInputLabels.CompanyName,
        companyName,
        setCompanyName,
        isMandatory
      )}
      <div>
        <h2 className={styles.inputTitle}>{ProviderInformationInputLabels.ContactPerson}</h2>
        <div className={styles.horizontalCentering}>
          {renderInput(
            ProviderInformationInputLabels.FirstName,
            contactPersonFirstName,
            setContactPersonFirstName,
            isMandatory
          )}
          {renderInput(
            ProviderInformationInputLabels.LastName,
            contactPersonLastName,
            setContactPersonLastName,
            isMandatory
          )}
        </div>
      </div>
      {renderInput(
        ProviderInformationInputLabels.CompanyRole,
        companyRole,
        setCompanyRole,
        isMandatory
      )}
      {renderInput(
        ProviderInformationInputLabels.ContactEmail,
        contactEmail,
        setContactEmail,
        isMandatory
      )}
      <div className={styles.horizontalCentering}>
        <BasicButton
          as={"button"}
          onClick={navigateForward}
          className={cx(commonStyles.primaryButton, styles.buttonPadding)}
          disabled={isDisabled()}
          textDecorationUnderline={true}
        >
          {StreamingButtonLabels.SubmitAndContinue}
        </BasicButton>
        <StreamingEuCloseButton />
      </div>
    </>
  );
};
